export default __webpack_public_path__ + "static/media/4-cassettes-open-4-left.bc1a9829.svg";